module.exports = __webpack_public_path__ + "static/media/hamburger.d346927b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hamburger.svg
// module id = 29
// module chunks = 0